import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {AutomaticPayment} from "../../../graphql/payments.datatypes";
import {gqlAutomaticPayment} from "../getAutomaticPayment.api";
import {updateCacheByType} from "../../../graphql/GraphQlProvider";

export interface UpdateAutomaticPaymentInput {
    data: {
        id: number
        payment_frequency: number
    }
}

interface UpdateAutomaticPaymentData {
    __typename?: string,
    updateAutomaticPayment: AutomaticPayment
}

export const UPDATE_AUTOMATIC_PAYMENT_MUTATION = gql`
    mutation updateAutomaticPayment($data: UpdateAutomaticPaymentInput!) {
        updateAutomaticPayment(data: $data) {
            ${gqlAutomaticPayment}
        }
    }
`;

export const updateAutomaticPayment = () => useMutation<UpdateAutomaticPaymentData, UpdateAutomaticPaymentInput>(
    UPDATE_AUTOMATIC_PAYMENT_MUTATION,
    {
        update: updateCacheByType('BillingParty'),
    }
);

export default updateAutomaticPayment;
